import React from "react";
import { Outlet } from "react-router-dom";
import SidebarComponent from "../../components/Sidebar";
import Navbar from "./Navbar";

const UserLayout = () => {
  return (
    <>
      <SidebarComponent>
        <Navbar />
        <Outlet />
      </SidebarComponent>
    </>
  );
};

export default UserLayout;
